import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const PhoneInput = ({ value, onChange, disabled }: PhoneInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow digits and limit to 10 characters
    const cleaned = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange(cleaned);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="phone">મોબાઇલ નંબર</Label>
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center w-14 h-10 bg-muted border rounded-md text-sm font-medium">
          +91
        </div>
        <Input
          id="phone"
          type="tel"
          placeholder="9876543210"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          maxLength={10}
          className="flex-1"
        />
      </div>
      {value && value.length === 10 && (
        <p className="text-xs text-green-600">✓ Valid phone number</p>
      )}
    </div>
  );
};
